const debounce = (callback, delay = 500) => {
  let timeout;
  return (...args) => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = null;
      callback(...args);
    }, delay);
  };
};

export const throttle = (callback, limit) => {
  let wait = false;
  return (...args) => {
    if (!wait) {
      callback(...args);
      wait = true;
      setTimeout(() => {
        wait = false;
      }, limit);
    }
  };
};

const setToken = (token) => {
  localStorage.setItem('token', token);
};

const getToken = () => localStorage.getItem('token');

const removeToken = () => {
  localStorage.removeItem('token');
};

const checkErrorBoundary = (err) => {
  const error = {
    status: '',
    message: 'Something went wrong.',
    hasError: true,
    type: '',
  };
  const status = err?.response?.status;
  // const message = err?.response?.data?.message;
  const errorBoundaryStatusCodes = [405, 500, 501, 502, 503];
  if (status && errorBoundaryStatusCodes.includes(status)) {
    error.status = status;
    error.message = 'Something went wrong. Please refresh/try after some time';
    error.type = 'errorBoundary';
  }

  if (['500', '501', '502', '503', '405'].includes(err.message.replace(/\D/g, ''))) {
    return true;
  }

  if (!error.type && err?.message.includes('Network Error')) {
    error.message = 'Something went wrong. Please refresh/try after some time';
    error.type = 'errorBoundary';
    removeToken();
    localStorage.removeItem('persist:root');
  }

  return error;
};

const isValidEmail = (email) => {
  const re = /\S+@\S+\.\S+/;
  return re.test(email);
};

const isValidPassword = (password) => {
  const re = /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
  return re.test(password);
};

const toFixed = (data) => data.toFixed(2);

const isLastItem = (index, length) => index + 1 === length;

const onMobileKeyDown = (e) => {
  const key = e.keyCode ? e.keyCode : e.which;

  if (
    !(
      [8, 9, 13, 27, 46, 110, 190].indexOf(key) !== -1 ||
      (key === 65 && (e.ctrlKey || e.metaKey)) ||
      (key >= 35 && key <= 40) ||
      (key >= 48 && key <= 57 && !(e.shiftKey || e.altKey)) ||
      (key >= 96 && key <= 105)
    )
  ) {
    e.preventDefault();
  }
};
export {
  debounce,
  setToken,
  getToken,
  removeToken,
  checkErrorBoundary,
  isValidEmail,
  isValidPassword,
  toFixed,
  isLastItem,
  onMobileKeyDown,
};
